export const Contact=()=>{
    return (
        <div id="Contact">
        <div   className="contanct component__space">
            <div className="heading">
            <h1 className="heading">Contact</h1>
            <div className="row align__items__center justify__content__center">
                <div className="col__3">
               <a href="https://www.linkedin.com/in/bhavani-dasari-906134140/" target="_blank"><img src="https://img.shields.io/badge/LinkedIn-blue?style=for-the-badge&logo=linkedin&logoColor=white" alt="LinkedIn Badge"/></a>
               </div>
               <div className="col__3">
                <a href="bhavanidasari215@gmail.com" target="_blank"><img src="https://img.shields.io/badge/Gmail-red?style=for-the-badge&logo=gmail&logoColor=white" alt="Gmail Badge"/></a>
               </div>
               <div className="col__3">
                <a href="https://github.com/BHAVANI-DASARI"><img src="https://img.shields.io/badge/GitHub-white?style=for-the-badge&logo=github&logoColor=black" alt="GitHub Badge"/></a>
                </div>
            </div>

            </div>
        </div> 
        </div>
    )
}